import React, { useEffect, useRef, useState } from 'react'
import { Marker } from 'react-google-maps'
import { useSelector } from 'react-redux'
import InfoBox from 'react-google-maps/lib/components/addons/InfoBox'
import { Card, Icon } from 'antd'

import MapContainer from 'src/components/MapContainer'
import { ApplicationState } from 'src/store'
import { Id } from 'src/types'

import ItineraryItem from '../ItineraryItem'

function Map() {
  const { myTeam } = useSelector((state: ApplicationState) => ({
    myTeam: state.myTeam
  }))

  const refMap = useRef(null)

  const [openItineraryId, setOpenItineraryId] = useState<Id>()

  useEffect(() => {
    setTimeout(() => {
      const map =
        refMap.current && refMap.current.state && refMap.current.state.map

      if (map) {
        // @ts-ignore
        const bounds = new window.google.maps.LatLngBounds()

        myTeam.list.forEach(({ latitude, longitude }) => {
          // @ts-ignore
          bounds.extend(new window.google.maps.LatLng(latitude, longitude))
        })

        map.fitBounds(bounds, 50)
      }
    }, 500)
  }, [myTeam.list])

  return (
    <div style={{ height: '800px' }}>
      <MapContainer ref={refMap}>
        {myTeam.list.map(item => (
          <Marker
            key={item.request_itinerary_id}
            onClick={() => setOpenItineraryId(item.request_itinerary_id)}
            position={{ lat: +item.latitude, lng: +item.longitude }}
          >
            {openItineraryId === item.request_itinerary_id && (
              <InfoBox options={{ enableEventPropagation: true }}>
                <Card
                  bodyStyle={{ maxWidth: '300px' }}
                  extra={[
                    <Icon
                      onClick={() => setOpenItineraryId(null)}
                      type="close"
                    />
                  ]}
                >
                  <ItineraryItem item={item} />
                </Card>
              </InfoBox>
            )}
          </Marker>
        ))}
      </MapContainer>
    </div>
  )
}

export default Map
